import ErrorMessage from "../components/form/ErrorMessage";
import Button from "../../сomponents/UI/Buttons/Button";
import ProcessLoading from "../../сomponents/UI/loading/ProcessLoading";

import './EditPageLayout.sass'

const EditPageLayout = ({pageTitle, actionName, errorMessage, showProcessLoading, isDone, onSubmit, children}) => {
    return (
        <section>
            <h1>{pageTitle}</h1>

            <form onSubmit={onSubmit}>
                {children}

                {errorMessage.length !== 0 && <ErrorMessage message={errorMessage} />}

                <div className="d-flex align-items-center">
                    <Button className='my-2 mr-2'>{actionName}</Button>
                    {showProcessLoading && <ProcessLoading done={isDone} /> }
                </div>
            </form>
        </section>
    );
};

export default EditPageLayout;